module.exports = __webpack_public_path__ + "media/Loading_Apples_in_Nelson.45685da7.mp4";